export enum TypeScroll {
    up = 'Вверх',
    down = 'Вниз',
  }